import CreateSessionModal from 'components/Basic Modal/CreateSessionModal';
import ErrorAlert from 'components/Basic Modal/ErrorAlert';
import FloorPlanCard from 'components/FloorPlanCard';
import PageTitle from 'components/PageTitle';
import React, { useEffect } from 'react';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Col, Row, Spinner } from 'reactstrap';
import { getAllOrders } from 'store/actions/floorPlanActions';
import { retrieveAllSessions } from 'store/actions/sessionAction';

import io from 'socket.io-client';
import '../../../assets/scss/ComponentsCss/session.scss';

const FloorPlans = () => {
  const dispatch = useDispatch();
  const [warn, setWarn] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState({});
  const [openAddSessionModal, setOpenAddSessionModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState('not_paid'); // valori possibili: 'not_paid', 'paid', 'all'
  const [searchTable, setSearchTable] = useState('');

  const { removeSessionLoader, getFloorPlansLoader, allOrders } = useSelector(
    (state) => state.floor_plans
  );

  const { allSessions } = useSelector((state) => state.session);
  
  // Recupero il blId dal session storage
  const blId = sessionStorage.getItem('blId');

  // Recupero il numero totale degli ordini
  const activeSessionsCount = orders.filter((o) => o.payment_status !== 'paid').length;
  const completedSessionsCount = orders.filter((o) => o.payment_status === 'paid').length;
  const totalSessionsCount = orders.length;

  // Recupero il totale da pagare degli ordini
  const totalToBePaid = orders
    .filter((o) => o.payment_status !== 'paid')
    .reduce((sum, o) => {
      const orderTotal =
        o.salesEntries?.reduce((subSum, entry) => subSum + (entry.itemPrice || 0), 0) || 0;
      return sum + orderTotal;
    }, 0);

  // Recupero il totale pagato degli ordini
  const totalPaid = orders
    .filter((o) => o.payment_status === 'paid')
    .reduce((sum, o) => {
      const orderTotal =
        o.salesEntries?.reduce((subSum, entry) => subSum + (entry.itemPrice || 0), 0) || 0;
      return sum + orderTotal;
    }, 0);

  // Recupero il totale degli ordini 
  const totalAmount = orders.reduce((sum, o) => {
    const orderTotal =
      o.salesEntries?.reduce((subSum, entry) => subSum + (entry.itemPrice || 0), 0) || 0;
    return sum + orderTotal;
  }, 0);

  useEffect(() => {
    // Effettuo la richiesta per recuperare tutti gli ordini
    dispatch(getAllOrders(blId));

    // Effettuo la richiesta per recuperare tutte le sessioni attive
    dispatch(retrieveAllSessions(blId));
  }, [blId]);

  useEffect(() => {
    // processing
    io.connect(process.env.REACT_APP_BackendURL).on('updateProcess', () => {
      // Effettuo la richiesta per recuperare tutti gli ordini
      dispatch(getAllOrders(blId));

      // Effettuo la richiesta per recuperare tutte le sessioni attive
      dispatch(retrieveAllSessions(blId));
    });
  }, []);

  useEffect(() => {
    // Ascolto la socket per la ricezione di una nuova sessione
    io.connect(process.env.REACT_APP_BackendURL).on('order_received', async () => {
      // Effettuo la richiesta per recuperare tutti gli ordini
      dispatch(getAllOrders(blId));

      // Effettuo la richiesta per recuperare tutte le sessioni attive
      dispatch(retrieveAllSessions(blId));
    });
  }, []);

  // Scorro tutti gli ordini per effettuare
  // un match con ordini-sessioni
  useEffect(() => {
    // Verifico se sono presenti sessioni e ordini per orocedere
    if (allSessions?.length && allOrders?.length) {
      let array = [];

      allOrders
        ?.filter((_item) => _item.isParent)
        ?.forEach((item) => {
          // Verifico se l'ordine è presente nelle sessioni
          let isExsist = allSessions?.find(
            (_itm) => _itm?._id === item?.sessionId && item?.salesEntries?.length
          );

          // Se preseente, lo aggiungo nell'array
          if (isExsist?._id) {
            array.push({
              ...item,
              ...isExsist
            });
          }
        });

      // Aggiungo l'array con gli ordini, alla variabile orders
      setOrders([...array]);
    }
  }, [allSessions, allOrders]);

  return (
    <>
      <Row className="p-3">
        <Col lg="6" sm="12" md="6" xs="12">
          <div className="p-2">
            <PageTitle icon={'/img/sidebar/ic_session.png'} title="Sessions" />
          </div>
        </Col>
        <Col lg="12" sm="12" md="12">
          <div className="mt-3 d-none d-md-block">
            <Row>
              <Col xs="12" lg="3" md="3" className="d-flex gap-2 mb-2 mb-md-0">
                <button
                  className={`btn ${
                    filterStatus === 'not_paid' ? 'btn-primary' : 'btn-outline-primary'
                  } segment-button`}
                  onClick={() => setFilterStatus('not_paid')}>
                  Active sessions
                </button>
                <button
                  className={`btn ${
                    filterStatus === 'paid' ? 'btn-primary' : 'btn-outline-primary'
                  } segment-button`}
                  onClick={() => setFilterStatus('paid')}>
                  Closed sessions
                </button>
                <button
                  className={`btn ${
                    filterStatus === 'all' ? 'btn-primary' : 'btn-outline-primary'
                  } segment-button`}
                  onClick={() => setFilterStatus('all')}>
                  All
                </button>
              </Col>

              <Col xs="12" lg="3" md="3">
                <input
                  type="text"
                  placeholder="Search table..."
                  value={searchTable}
                  onChange={(e) => setSearchTable(e.target.value)}
                  className="form-control w-100 m-0"
                  style={{ maxWidth: '350px' }}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col xs="12" md="4" lg="4">
                <div className="bg-light p-2 rounded border text-center">
                  <strong>Active sessions:</strong> {activeSessionsCount}
                </div>
              </Col>
              <Col xs="12" md="4" lg="4">
                <div className="bg-light p-2 rounded border text-center">
                  <strong>Sessions closed:</strong> {completedSessionsCount}
                </div>
              </Col>
              <Col xs="12" md="4" lg="4">
                <div className="bg-light p-2 rounded border text-center">
                  <strong>Total sessions:</strong> {totalSessionsCount}
                </div>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col xs="12" md="4" lg="4">
                <div className="bg-light p-2 rounded border text-center">
                  <strong>Total to be paid:</strong> {totalToBePaid.toFixed(2)} €
                </div>
              </Col>
              <Col xs="12" md="4" lg="4">
                <div className="bg-light p-2 rounded border text-center">
                  <strong>Total paid:</strong> {totalPaid.toFixed(2)} €
                </div>
              </Col>
              <Col xs="12" md="4" lg="4">
                <div className="bg-light p-2 rounded border text-center">
                  <strong>Total:</strong> {totalAmount.toFixed(2)} €
                </div>
              </Col>
            </Row>
          </div>

          <div className="d-block d-md-none">
            <Row className="my-2">
              {/* Pulsante filtro OPEN */}
              <Col xs="4" md="4">
                <button
                  className={`btn ${
                    filterStatus === 'not_paid' ? 'btn-primary' : 'btn-outline-primary'
                  } segment-button w-100`}
                  onClick={() => setFilterStatus('not_paid')}>
                  OPEN
                  <Col className="bg-white text-dark rounded text-center">
                    <Row className="d-flex justify-content-center text-center py-1">
                      {activeSessionsCount.toFixed(2)}
                    </Row>

                    <div
                      style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#000',
                        margin: 'auto',
                        minHeight: '1px'
                      }}
                    />

                    <Row className="d-flex justify-content-center text-center py-1">
                      {totalToBePaid.toFixed(2)} €
                    </Row>
                  </Col>
                </button>
              </Col>

              {/* Pulsante filtro CLOSED */}
              <Col xs="4" md="4">
                <button
                  className={`btn ${
                    filterStatus === 'paid' ? 'btn-primary' : 'btn-outline-primary'
                  } segment-button w-100`}
                  onClick={() => setFilterStatus('paid')}>
                  CLOSED
                  <Col className="bg-white text-dark rounded text-center">
                    <Row className="d-flex justify-content-center text-center py-1">
                      {completedSessionsCount.toFixed(2)}
                    </Row>

                    <div
                      style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#000',
                        margin: 'auto',
                        minHeight: '1px'
                      }}
                    />

                    <Row className="d-flex justify-content-center text-center py-1">
                      {totalPaid.toFixed(2)} €
                    </Row>
                  </Col>
                </button>
              </Col>

              {/* Pulsante filtro ALL */}
              <Col xs="4" md="4">
                <button
                  className={`btn ${
                    filterStatus === 'all' ? 'btn-primary' : 'btn-outline-primary'
                  } segment-button w-100`}
                  onClick={() => setFilterStatus('all')}>
                  ALL
                  <Col className="bg-white text-dark rounded">
                    <Row className="d-flex justify-content-center text-center py-1">
                      {totalSessionsCount}
                    </Row>

                    <div
                      style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#000',
                        margin: 'auto',
                        minHeight: '1px'
                      }}
                    />

                    <Row className="d-flex justify-content-center text-center py-1">
                      {totalAmount.toFixed(2)} €
                    </Row>
                  </Col>
                </button>
              </Col>
            </Row>

            <Row>
              <Col xs="12" sm="12" md="12">
                <input
                  type="text"
                  placeholder="Search table..."
                  value={searchTable}
                  onChange={(e) => setSearchTable(e.target.value)}
                  className="form-control w-100 m-0"
                />
              </Col>
            </Row>
          </div>

          {getFloorPlansLoader ? (
            <Spinner className="d-flex mx-auto mt-5" size="lg" color="primary" />
          ) : (
            <Row className="p-3">
              {orders &&
                orders
                  ?.filter((data) => {
                    const matchesStatus =
                      filterStatus === 'all' ||
                      (filterStatus === 'not_paid' && data.payment_status !== 'paid') ||
                      (filterStatus === 'paid' && data.payment_status === 'paid');

                    const matchesSearch =
                      !searchTable || data.tableNumber?.toString().includes(searchTable.trim());

                    return matchesStatus && matchesSearch;
                  })
                  .map((data) => (

                    <FloorPlanCard
                      key={data._id}
                      data={data}
                      blId={blId}
                      setSelectedOrder={setSelectedOrder}
                      setWarn={setWarn}
                      setAlertMsg={setAlertMsg}
                      loading={removeSessionLoader}
                      setOpenAddSessionModal={setOpenAddSessionModal}
                      openAddSessionModal={openAddSessionModal}
                    />
                  ))}
            </Row>
          )}
        </Col>
      </Row>

      <ErrorAlert alert={warn} setAlert={setWarn} alertMessage={alertMsg} />
      <CreateSessionModal
        setWarn={setWarn}
        setAlertMsg={setAlertMsg}
        setOpenAddSessionModal={setOpenAddSessionModal}
        selectedOrder={selectedOrder}
        openAddSessionModal={openAddSessionModal}
      />
    </>
  );
};

export default FloorPlans;
